import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

type Props = {
  label?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange: (value: boolean) => void;
  id: string;
  disabled?: boolean;
  className?: string;
};

const Switch = ({
  defaultChecked,
  checked,
  onChange,
  label,
  id,
  disabled,
  className,
}: Props) => {
  return (
    <>
      <SwitchPrimitive.Root
        className={cn(
          "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "data-[state=checked]:bg-accent data-[state=unchecked]:bg-primary",
          className
        )}
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        onCheckedChange={onChange}
        disabled={disabled}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm ring-0 transition-transform",
            "data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
          )}
        />
      </SwitchPrimitive.Root>
      {label && (
        <label
          className="text-sm font-medium leading-none pl-2 cursor-pointer"
          htmlFor={id}
        >
          {label}
        </label>
      )}
    </>
  );
};

export default Switch;
